/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState, useEffect, useCallback } from 'react';
import Form from './Form';
import * as Components from './styles';
export var getEndpoint = function getEndpoint() {
  return (process.env.WDDING_API || process.env.FORM_API || '') + '/wedding';
};
var LOCAL_STORAGE_KEY = '__swp_wedding_pwd__';

function getData(code) {
  return window.fetch(getEndpoint() + '?site=' + (process.env.SITE_ID || '') + '&code=' + code).then(function (response) {
    if (response.status !== 200) {
      throw response;
    }

    return response;
  }).then(function (response) {
    return response.json();
  });
}

function readLocalStorage() {
  try {
    return window.localStorage.getItem(LOCAL_STORAGE_KEY) || '';
  } catch (error) {
    return '';
  }
}

export function WeddingForm(props) {
  var _useState = useState(readLocalStorage),
      code = _useState[0],
      setCode = _useState[1];

  var _useState2 = useState(code),
      initialCode = _useState2[0];

  var _useState3 = useState(code ? 'loading' : 'idle'),
      fetchState = _useState3[0],
      setFetchState = _useState3[1];

  var _useState4 = useState(null),
      fetchResponse = _useState4[0],
      setFetchResponse = _useState4[1];

  useEffect(function () {
    if (props.edit) {
      return;
    }

    if (!initialCode) {
      return;
    }

    setFetchState('loading');
    getData(initialCode).then(function (response) {
      setFetchResponse(response);
      setFetchState('finished');
    })["catch"](function (error) {
      setFetchState('idle');
      setCode('');
      window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    })["catch"](console.error);
  }, [initialCode, props.edit]);

  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    setFetchState('loading');
    getData(code).then(function (response) {
      setFetchResponse(response);
      setFetchState('finished');
      window.localStorage.setItem(LOCAL_STORAGE_KEY, code);
    })["catch"](function (error) {
      setFetchState('error');
    })["catch"](console.error);
  };

  if (props.edit) {
    return jsx("p", {
      className: "mt--20 mb--20 pl--20 pr--20 ta--c"
    }, "Svatebn\xED formul\xE1\u0159 nen\xED administrovateln\xFD na t\xE9to str\xE1nce");
  }

  var isLoading = fetchState === 'loading';

  if (!code || fetchState !== 'finished') {
    return jsx(Components.Section, null, jsx(Components.CodeForm, {
      onSubmit: onSubmit
    }, jsx(Components.Flex, null, jsx(Components.CodeInput, {
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      spellCheck: "false",
      name: "code",
      value: code,
      onChange: function onChange(e) {
        return setCode(e.target.value);
      },
      disabled: isLoading,
      size: 10
    }), jsx(Components.Submit, {
      css: isLoading ? Components.loading : null,
      disabled: isLoading
    }, "P\u0159ihl\xE1sit")), fetchState === 'error' ? jsx(Components.Error, {
      className: "mt--10"
    }, "Neplatn\xE9 heslo") : null));
  }

  return jsx(Components.Section, null, jsx(Form, {
    code: code,
    initialState: fetchResponse.initialState,
    fields: fetchResponse.fields
  }), jsx(Components.Flex, {
    className: "mt--20"
  }, jsx(Components.Submit, {
    onClick: function onClick() {
      return setCode('');
    }
  }, "Odhl\xE1sit")));
}